import React, { Component } from "react";
import axios from "axios";
import Empty from "../../image/empty.svg"
import { CiLock } from "react-icons/ci";


class CourseVideo extends Component {
    state = {
        course: [],
        windowWidth: window.innerWidth,
        currentVideo: [],
        thumbnailUrl: null, // Add thumbnail state
        showThumbnail: true, // Add showThumbnail state
    }
    videoRef = React.createRef();
    componentDidMount() {
        this.setState({course: this.props.course})
        window.addEventListener('resize', this.handleResize); // Add resize listener
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize); // Remove listener
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.shouldRefresh && this.props.shouldRefresh !== prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone();
        }
        if (this.state.currentVideo !== prevState.currentVideo && this.videoRef.current) {
            this.videoRef.current.load();
        }
        if (this.props.course !== prevProps.course) {
            this.setState({course: this.props.course})
            // this.fetchCourses();
        }
        if (this.state.course.videos && this.state.course.videos.length > 0 && !prevState.course.videos) {
            this.setInitialVideo();
        }
    }
    setInitialVideo = () => {
        const firstVideo = this.state.course.videos[0];
        if (firstVideo) {
            this.setState({
                currentVideo: firstVideo,
                thumbnailUrl: firstVideo.thumbnail,
            });
        }
    };
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth }); // Update window width on resize
    };
    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");

    //     try {
    //         const course_id = this.props.course_id
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //         if (accessToken) {
    //             headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //             };
    //         }

    //         const response = await axios.get("https://api.geoinfoacademy.com/api/courses/" + courseId, {
    //             headers: headers,
    //         });
    //         this.setState({ course: response.data });
    //         console.log("API Response:", response.data);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };
    handleVideoClick(video) {
        this.setState({ currentVideo: video });
    }



    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in
         
        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/interested-courses/`,
                {
                    course_id: course_id, // Place course_id in the request body
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            console.log(response.data.message)
            window.location.href = `/description/${course_id}/paymentverify`; 
        }
        catch (error) {
            console.error("Error initiating payment:", error);
        }

    }else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }
    };



    render() {

        const video = this.state.course;
        const videoCount = video && video.videos ? video.videos.length : 1;
        const videolist = video && video.videos && video.videos.length ? (
            video.videos.map((video) => {
                return (
                    <div className="course_cover video" key={video.id} >
                        <button className="switch" onClick={() => this.handleVideoClick(video)}>
                            <div className="image" >
                                <video><source src={video.file_path} type="video/mp4" /></video>
                            </div>
                            </button>
                            <div className="about">
                                <h4>
                                    <span>{this.state.course.labels}</span><br />
                                    {video.title}
                                </h4>
                                {/* <p></p> */}
                                <button className="edit">{video.order}</button>
                            </div>
                        
                    </div>
                );
            })
        ) : (
            <div className="empty_video" >
                <img src={Empty} alt="empty" />
                <h4>No Video</h4>
            </div>
        );
        const { currentVideo, thumbnailUrl, showThumbnail  } = this.state;

        const scrollWidth = this.state.windowWidth < 1000 ? 300 * videoCount : "auto";
        return (
            <section className="describe_video_container">
                <h3>Course Videos</h3>

                {this.state.course.enrolled !== true ?
                    <div className="enroll_error">
                        <div className="enroll_cover">
                            <CiLock />
                            <p>Enroll For Course To Gain Access</p>
                            <button onClick={this.handleRedirect}>Apply For Course</button>
                        </div>
                    </div>

                    :
                    <div>
                        <div className="video_view">
                            {currentVideo ? (
                        showThumbnail ? (
                            <img src={thumbnailUrl} alt="Video Thumbnail" onClick={() => this.setState({ showThumbnail: false })} style={{ cursor: 'pointer', maxWidth: '100%', minHeight: '300px' }}/>
                        ) : (
                        <video controls height="300" ref={this.videoRef} autoPlay>
                            <source src={currentVideo.file_path} type="video/mp4" />
                        </video>
                    ) ) : (
                                <p>No video selected.</p>
                            )}
                        </div>
                        <div className="list_course_video">
                            <div className="course_scroll" style={{ width: scrollWidth }}>
                                {videolist}
                            </div>

                        </div>
                    </div>}
                {/* <div className="video_comment">
                    <h3>Comment section</h3>
                    <textarea placeholder="Any questions?" />
                </div> */}
            </section>

        )
    }
}

export default CourseVideo